const myProjects = [
{
    id: 'project1',
    img: 'img/rcontrol.jpg',
    alt: 'site de serviços com sistemas de segurança',
    pagelink: 'https://rcontroltec.com/',
    repositorylink: 'https://github.com/JoaoP-Sa/rcontrol',
    projectdescription: "Primeiro projeto comercial que fiz, este projeto foi feito como fruto de um serviço que prestei como freelancer, e se trata de uma página que criei para uma empresa que trabalha com serviços de instalação de sistemas de segurança"
},
{
    id: 'project2',
    img: 'img/gallery.jpg',
    alt: 'site de galeria de fotos',
    pagelink: 'http://gallery-project.great-site.net/?i=1',
    repositorylink: 'https://github.com/JoaoP-Sa/galeria',
    projectdescription: "Primeiro projeto com PHP e MySQL que fiz sozinho, ele consiste em uma galeria de fotos com sistema de login, no qual a pessoa faz o cadastro e salva suas fotos em sua conta, o projeto tem as opções de enviar e excluir fotos, que possuem título e descrição",
},
{
    id: 'project3',
    img: 'img/interactive-pricing-component.jpg',
    alt: 'site com componente de preço interativo',
    pagelink: 'https://jp-interactive-pricing-component.netlify.app/',
    repositorylink: 'https://github.com/JoaoP-Sa/interactive_pricing_component',
    projectdescription: "Esta é uma página que peguei no frontend mentor, e ela consiste em um componente de preços interativo, no qual é possivel manipular através de uma barra, e existe a opção de aplicar desconto no preço caso o botão de cobrança esteja posicionado para fazer a cobrança anual."
},
{
    id: 'project4',
    img: 'img/sunnyside.jpg',
    alt: 'site de serviços de design',
    pagelink: 'https://joaop-sa.github.io/sunnyside/',
    repositorylink: 'https://github.com/JoaoP-Sa/sunnyside',
    projectdescription: "Este link contém uma página que encontrei em um desafio do frontend mentor e decidi recriar utilizando html, css e javascript."
},{
    id: 'project5',
    img: 'img/analythics.jpg',
    alt: 'site de empresa de análise de dados',
    pagelink: 'https://joaop-sa.github.io/analythics_card/',
    repositorylink: 'https://github.com/JoaoP-Sa/analythics_card',
    projectdescription: "Outra página que criei com base em um desafio do frontend mentor, é uma página para uma empresa que trabalha com análise de dados. Utilizei html e css para criar a página."
},{
    id: 'project6',
    img: 'img/intro-component.jpg',
    alt: 'site de página de login',
    pagelink: 'https://jp-intro-component.netlify.app/',
    repositorylink: 'https://github.com/JoaoP-Sa/intro-component',
    projectdescription: "Peguei essa página em um desafio do frontend mentor, e ela consiste em uma tela de login de um site de cursos onde o usuário pode acompanhar outros programadores desenvolvendo seus projetos. Utilizei apenas react js e css para criar este projeto."
}];

export default myProjects;